import React from "react";
import OnboardingMember from "./OnboardingMember";
import store from "../init/store.js";
import { modelsFromObject } from "../helpers/models-from-object.js";
import audioManager from '../_audio/audio-manager'

class OnboardingMemberRow extends React.Component {
  props: {
    buddiesRevealed: boolean,
    showLaptop: boolean
  };

  componentWillReceiveProps(newProps) {
    //Play a sound when laptops pop up
    if (newProps.showLaptop && !this.props.showLaptop) {
      audioManager.playSfx("sfx_submitAction");
    }
  }

  getLeftMemberStyle() {
    return {
      position: "relative",
      left: "2em",
      transform: this.props.buddiesRevealed
        ? `translate3d(0,0,0)`
        : `translate3d(-7em,0,0)`,
      opacity: this.props.buddiesRevealed ? `1` : `0`,
      transition: "all 0.4s cubic-bezier(.77,0,.94,.81)"
    };
  }
  getRightMemberStyle() {
    return {
      position: "relative",
      left: "-2em",
      transform: this.props.buddiesRevealed
        ? `translate3d(0,0,0)`
        : `translate3d(7em,0,0)`,
      opacity: this.props.buddiesRevealed ? `1` : `0`,
      transition: "all 0.4s cubic-bezier(.77,0,.94,.81)"
    };
  }

  getMiddleMemberStyle() {
    return {
      position: "relative",
      top: "3em"
    };
  }

  render() {
    const crewMembers = modelsFromObject(store.getState().crew.members);
    const style = {
      display: "flex",
      justifyContent: "space-around"
    };

    return (
      <div style={style}>
        <div style={this.getLeftMemberStyle()}>
          <OnboardingMember
            skinId={crewMembers[1].skinId}
            showLaptop={this.props.showLaptop}
          />
        </div>
        <div style={this.getMiddleMemberStyle()}>
          <OnboardingMember
            skinId={crewMembers[0].skinId}
            showLaptop={this.props.showLaptop}
          />
        </div>
        <div style={this.getRightMemberStyle()}>
          <OnboardingMember
            skinId={crewMembers[2].skinId}
            showLaptop={this.props.showLaptop}
          />
        </div>
      </div>
    );
  }
}

export default OnboardingMemberRow;



// WEBPACK FOOTER //
// ./src/b5-onboarding/OnboardingMemberRow.js